/// <reference path="../../global/fn.js" />

(function ($) {
    $.widget("nsp.w_servicesTabs", {
        options: {
            transitionDuration: 200,
        },

        _create: function () {
            const self = this;

            self.element = this.element;
            self.tabs = self.element.find('[role="tab"]');
            self.panels = self.element.find('.s-services__panel-list [role="tabpanel"]');
            self.stickyNav = self.element.find(".s-services__nav");

            self.activeTab = self.tabs.filter('[aria-selected="true"]').length
                ? self.tabs.filter('[aria-selected="true"]')
                : self.tabs.first();

            self._initTabs();
            self._initializeBaseState();
            self._syncInitialHashPanel();
        },

        _initTabs: function () {
            const self = this;

            self.tabs.on("click", function (e) {
                const $tab = $(e.currentTarget);

                if ($tab.attr("aria-selected") === "true") return;

                const panelId = $tab.attr("aria-controls");
                const $newPanel = $(`#${panelId}`);

                self._activateTab($tab, $newPanel);
            });
        },

        _initializeBaseState: function () {
            const self = this;

            self.tabs.removeClass("is-active").attr("aria-selected", "false");
            self.activeTab.addClass("is-active").attr("aria-selected", "true");

            const initialPanelId = self.activeTab.attr("aria-controls");

            self.panels.removeClass("is-visible").attr("hidden", "");
            $(`#${initialPanelId}`).addClass("is-visible").removeAttr("hidden");
        },

        _syncInitialHashPanel: function () {
            const hash = window.location.hash;

            if (!hash) return;

            const $section = $(hash);
            if (!$section.length) return;

            const $panel = $section.closest('.s-services__panel[role="tabpanel"]');
            if (!$panel.length) return;

            const panelId = $panel.attr("id");
            const $tab = this.tabs.filter(`[aria-controls="${panelId}"]`);

            if ($tab.length && !$tab.is(this.activeTab)) {
                this._activateTab($tab, $panel, true);
            }
        },

        _activateTab: function ($tab, $panel, immediate) {
            const currentPanel = this.panels.filter(".is-visible");
            const panelId = $panel.attr("id");
            const showPanel = () => {
                this.panels.not($panel).removeClass("is-visible").attr("hidden", "");
                $panel.addClass("is-visible").removeAttr("hidden").css("opacity", 1);
                this.activeTab = $tab;
                $(document).trigger("services-panel-changed");
            };

            this.tabs.removeClass("is-active").attr("aria-selected", "false");
            $tab.addClass("is-active").attr("aria-selected", "true");

            if (currentPanel.attr("id") === panelId) {
                this.activeTab = $tab;
                return;
            }

            if (immediate) {
                showPanel();
                return;
            }

            currentPanel.css("opacity", 0);

            setTimeout(() => {
                showPanel();
            }, this.options.transitionDuration);
        },

        switchToTab: function (tabId) {
            const self = this;
            const $tab = self.tabs.filter(`#${tabId}`);
            if ($tab.length) {
                $tab.trigger("click");
            }
        },

        getActiveTab: function () {
            return this.activeTab;
        },

        getActivePanel: function () {
            return this.panels.filter(".is-visible");
        },
    });
})(jQuery);
